import { defineComponent, shallowRef, ref, computed } from "vue";
import { p as pick } from "../../../vendor-2b2dbafd.mjs";
import { a as useAccordionItem } from "../va-accordion/hooks/useAccordion-2a840d7c.mjs";
import { g as generateUniqueId } from "../../utils/uuid-7d2e5892.mjs";
import { V as VaIcon } from "../va-icon/index-b0729838.mjs";
import { u as useSelectableEmits } from "../../composables/useSelectable-f3520531.mjs";
import { u as useResizeObserver } from "../../composables/useResizeObserver-97916f85.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { a as useStatefulProps, b as useStateful } from "../../composables/useStateful-50e4a6b9.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
import { u as useTextColor } from "../../composables/useTextColor-d6b2d8c3.mjs";
import { u as useBem } from "../../composables/useBem-33d80128.mjs";
const _sfc_main = defineComponent({
  name: "VaCollapse",
  components: {
    VaIcon
  },
  props: {
    ...useComponentPresetProp,
    ...useStatefulProps,
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    header: { type: String, default: "" },
    icon: { type: String, default: "" },
    solid: { type: Boolean, default: false },
    color: { type: String, default: "background-element" },
    textColor: { type: String, default: "" },
    colorAll: { type: Boolean, default: false },
    flat: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", ...useSelectableEmits],
  setup(props, { emit, slots }) {
    const body = shallowRef();
    const { valueComputed } = useStateful(props, emit, "modelValue", { defaultValue: false });
    const { getColor, getHoverColor } = useColors();
    const { accordionProps, valueProxy: computedModelValue = valueComputed } = useAccordionItem();
    const { textColorComputed } = useTextColor();
    const bodyHeight = ref();
    useResizeObserver([body], () => {
      var _a;
      bodyHeight.value = ((_a = body.value) == null ? void 0 : _a.clientHeight) ?? 0;
    });
    const height = computed(() => computedModelValue.value ? bodyHeight.value : 0);
    const getTransition = () => {
      const duration = height.value / 1e3 * 0.2;
      return `${duration > 0.2 ? duration : 0.2}s`;
    };
    const getBackground = () => {
      return props.color && props.colorAll ? getHoverColor(getColor(props.color)) : "";
    };
    const uniqueId = computed(generateUniqueId);
    const headerIdComputed = computed(() => `header-${uniqueId.value}`);
    const panelIdComputed = computed(() => `panel-${uniqueId.value}`);
    const tabIndexComputed = computed(() => props.disabled ? -1 : 0);
    const headerAttributes = computed(() => ({
      id: headerIdComputed.value,
      tabindex: tabIndexComputed.value,
      "aria-controls": panelIdComputed.value,
      "aria-expanded": computedModelValue.value,
      "aria-disabled": props.disabled,
      role: "button"
    }));
    const computedClasses = useBem("va-collapse", () => ({
      ...pick(props, ["disabled", "solid", "flat"]),
      expanded: computedModelValue.value,
      active: props.solid && computedModelValue.value,
      popout: !!(accordionProps.value.popout && computedModelValue.value),
      inset: !!(accordionProps.value.inset && computedModelValue.value)
    }));
    const toggle = () => {
      if (props.disabled) {
        return;
      }
      computedModelValue.value = !computedModelValue.value;
    };
    return {
      body,
      height,
      toggle,
      computedModelValue,
      headerIdComputed,
      headerAttributes,
      panelIdComputed,
      tabIndexComputed,
      textColorComputed,
      computedClasses,
      headerStyle: computed(() => ({
        paddingLeft: props.icon && 0,
        color: textColorComputed.value,
        backgroundColor: props.color ? getColor(props.color) : ""
      })),
      contentStyle: computed(() => {
        return {
          visibility: computedModelValue.value ? "visible" : "hidden",
          height: `${height.value}px`,
          transitionDuration: getTransition(),
          background: computedModelValue.value ? getBackground() : ""
        };
      })
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaCollapse.css';
//# sourceMappingURL=VaCollapse.vue_vue_type_script_lang-b3c2d39a.mjs.map
